<template>
  <b-modal
    size="lg"
    title="ADICIONAR ITEM"
    id="add_item"
    hide-footer
    no-close-on-backdrop
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <!-- <div class="d-flex align-items-center justify-content-between">
      <v-btn @click="$bvModal.show('new_product')" class="btn-add">
        <i class="fas fa-plus mr-2 text-twenty"></i> NOVO PRODUTO
      </v-btn>
      <v-btn @click="$bvModal.show('new_medicine')" class="btn-add">
        <i class="fas fa-plus mr-2 text-twenty"></i> NOVO MEDICAMENTO
      </v-btn>
    </div> -->
    <b-form @submit.prevent="evOnSubmit">
      <b-row>
        <b-col>
          <v-autocomplete-default
            :items="stock_items"
            item-text="name"
            item-value="id"
            label="DIGITE PARA PESQUISAR..."
            v-model="stock_item_id"
            @search="handleSearch"
            @change="handleChange"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="QUANTIDADE" />
          <v-text-field-default
            type="text"
            label=""
            :suffix="
              unit_of_measurement ? unit_of_measurement.abbreviation : ''
            "
            v-model="amount"
            @input="handleInputAmount"
          />
        </b-col>
        <b-col v-if="stock_item && stock_item.stock_item_type == 'PRODUCT'">
          <label-required-field
            :label="`QUANTIDADE EM ${stock_item.stock_item_unit_of_measurement_abbreviation}`"
          />
          <v-text-field-default
            disabled
            type="text"
            label=""
            v-model="quantity"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>LOTE</label>
          <v-text-field-default label="" v-model="lot" />
        </b-col>
        <b-col>
          <label> DESCRIÇÃO </label>
          <v-text-field-default label="" v-model="description" />
        </b-col>
        <b-col>
          <label>DATA DE VALIDADE</label>
          <v-text-field-default
            :type="stock_item_type == 'PRODUCT' ? 'date' : 'month'"
            label=""
            v-model="due_date"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label-required-field label="GRUPO" />
          <v-autocomplete-default
            label=""
            :items="available_groups"
            v-model="stock_group_id"
          />
        </b-col>
        <b-col>
          <label>VALOR UNITÁRIO</label>
          <v-text-field
            outlined
            dense
            disabled
            type="text"
            v-model="unitary_value"
            @input="handleUnitaryValue"
          />
        </b-col>
        <b-col>
          <label>VALOR TOTAL</label>
          <v-text-field
            outlined
            dense
            type="text"
            v-model="value"
            @input="handleValue"
          />
        </b-col>
      </b-row>
      <warning-required-fields />
      <errors-messages :errors="errors" />
      <b-row align-h="end">
        <b-col cols="auto">
          <v-btn-save :disabled="btnSaveDisabled" type="submit" />
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import VBtnSave from "../../../Components/VBtnSave.vue";
import VAutocompleteDefault from "../../../Components/VAutocompleteDefault.vue";
import VTextFieldDefault from "../../../Components/VTextFieldDefault.vue";
import ErrorsMessages from "../../../Components/ErrorsMessages.vue";
import WarningRequiredFields from "../../../Components/WarningRequiredFields.vue";
import LabelRequiredField from "../../../Components/LabelRequiredField.vue";

import { formatValueOnKeyUp } from "../../../../lib/format";

export default {
  name: "AddItem",

  components: {
    VBtnSave,
    VAutocompleteDefault,
    VTextFieldDefault,
    ErrorsMessages,
    WarningRequiredFields,
    LabelRequiredField,
  },

  props: {
    stock_item_units_of_measurement: { type: Array, required: true },
    stock_items: { type: Array, required: true },
    stock_groups: { type: Array, required: true },
    stock_item_categories: { Type: Array, required: true },
    stock_group_has_stock_item_category: { type: Array, required: true },
    stock_owner_group_id: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data() {
    return {
      errors: [],
      loading: false,

      stock_item: null,
      stock_item_id: null,
      amount: "",
      quantity: "",
      size: "",
      unit_of_measurement_abbreviation: "",
      lot: "",
      description: "",
      due_date: "",
      stock_group_id: null,
      value: "",
      unitary_value: "",
      stock_item_type: "",
    };
  },

  computed: {
    unit_of_measurement() {
      if (!this.stock_item) return undefined;

      return this.stock_item_units_of_measurement.find(
        (unit) => unit.id === this.stock_item.stock_item_unit_of_measurement_id
      );
    },

    available_groups() {
      return this.stock_groups;
    },

    btnSaveDisabled() {
      if (this.stock_item_id === null) return true;
      if (!this.amount) return true;
      if (this.stock_item_type == "MEDICINE" && !this.lot) return true;
      if (this.stock_group_id === null) return true;
      if (!this.value) return true;

      return false;
    },
  },

  created() {
    this.retrieve().then();
  },

  methods: {
    formatValueOnKeyUp,

    handleSearch(value) {
      this.$emit("search", value);
    },

    handleInputAmount() {
      let { stock_item, amount, value } = this;

      if (stock_item) {
        let { size } = stock_item;

        if (amount) {
          amount = String(amount).replace(",", ".");

          this.quantity = parseFloat(amount) * parseFloat(size);

          value = String(value)
            .replace(".", "")
            .replace(".", "")
            .replace(".", "")
            .replace(".", "")
            .replace(",", ".");

          let unitary_value = parseFloat(value) / parseFloat(amount);

          this.unitary_value = formatValueOnKeyUp(
            String(unitary_value.toFixed(2))
          );
        }
      }
    },

    handleChange(id) {
      let { stock_items } = this;

      let stock_item = stock_items.find((item) => item.id == id);

      if (stock_item) {
        this.stock_item = stock_item;
        this.stock_item_type = stock_item.stock_item_type;
        this.quantity = stock_item.size;
        this.size = stock_item.size;
        this.unit_of_measurement_abbreviation =
          stock_item.stock_item_unit_of_measurement_abbreviation;
      }
    },

    handleValue(value) {
      this.value = formatValueOnKeyUp(value);
      this.handleInputAmount();
    },

    handleUnitaryValue(unitary_value) {
      // let { amount } = this;

      // if (amount) {
      //   amount = String(amount).replace(",", ".");
      //   unitary_value = String(unitary_value)
      //     .replace(",", "")
      //     .replace(".", "")
      //     .replace(".", "")
      //     .replace(".", "");

      //   let total_value = parseFloat(amount) * parseFloat(unitary_value);

      //   this.value = formatValueOnKeyUp(String(total_value));
      // }

      this.unitary_value = formatValueOnKeyUp(unitary_value);
    },

    async retrieve() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        let {
          stock_item,
          stock_item_id,
          amount,
          quantity,
          size,
          unit_of_measurement_abbreviation,
          lot,
          description,
          due_date,
          stock_group_id,
          value,
          unitary_value,
          stock_item_type,
        } = this;

        if (stock_item_type == "MEDICINE") {
          if (!lot) {
            this.errors = ["Informe o lote"];
            this.loading = false;
            return;
          }

          if (!due_date) {
            this.errors = ["Informe a data de vencimento"];
            this.loading = false;
            return;
          }
        }

        this.$emit("created", {
          stock_item_id,
          amount,
          quantity,
          size,
          unit_of_measurement_abbreviation,
          lot,
          description,
          due_date,
          stock_group_id,
          value,
          unitary_value,
          stock_item_type,
          medicine_id: stock_item.medicine_id,
          product_id: stock_item.product_id,
          name:
            stock_item_type == "MEDICINE"
              ? stock_item.medicine_name
              : stock_item.product_name,
        });

        this.$bvModal.hide("add_item");
        this.errors = [];
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnShow() {
      this.stock_item_id = null;
      this.amount = "";
      this.lot = "";
      this.description = "";
      this.due_date = "";
      this.stock_group_id = null;
      this.amount = "";
      this.value = "";
    },

    async evOnShown() {
      if (!this.stock_group_id) {
        this.stock_group_id = this.stock_owner_group_id;
      }
    },
  },
};
</script>

<style>
</style>